import { ViewportType } from 'game-ui-types'

export const configTypeB = {
    [ViewportType.DESKTOP]: {
        playButton: 'absolute left-[1528px] top-[832px] mt-[10px]',
        paginationSection:
            'absolute top-[968px] flex gap-[20px] left-[31%] -translate-x-1/2 -translate-y-1/2 items-center',
        checkBoxSection: 'absolute left-[1520px] top-[957px] flex gap-[20px] items-center',
        rightArrowButton: 'absolute left-[1003px] top-[934px]',
        leftArrowButton: 'absolute left-[113px] top-[934px] -scale-x-100',
        featureDescription:
            'absolute left-[53px] top-[736px] w-[1080px] h-[144px] font-bold text-[40px] leading-[48px] text-center px-[60px]',
    },
    [ViewportType.MOBILE_PORTRAIT]: {
        playButton: 'absolute left-[266px] top-[1228px] mt-[10px]',
        paginationSection:
            'absolute top-[1140px] flex gap-[20px] left-[50%] -translate-x-1/2 -translate-y-1/2 items-center',
        checkBoxSection: 'absolute left-[258px] top-[1356px] flex gap-[20px] items-center',
        rightArrowButton: 'absolute left-[680px] top-[1106px]',
        leftArrowButton: 'absolute left-[60px] top-[1106px] -scale-x-100',
        featureDescription:
            'absolute left-[0px] top-[970px] w-[810px] h-[108px] font-bold text-[30px] leading-[36px] text-center px-[60px]',
    },
    [ViewportType.MOBILE_LANDSCAPE]: {
        playButton: 'absolute left-[1048px] top-[598px] mt-[10px]',
        paginationSection:
            'absolute top-[734px] flex gap-[20px] left-[31%] -translate-x-1/2 -translate-y-1/2 items-center',
        checkBoxSection: 'absolute left-[1040px] top-[726px] flex gap-[20px] items-center',
        rightArrowButton: 'absolute left-[720px] top-[700px]',
        leftArrowButton: 'absolute left-[100px] top-[700px] -scale-x-100',
        featureDescription:
            'absolute left-[40px] top-[552px] w-[810px] h-[108px] font-bold text-[30px] leading-[36px] text-center px-[60px]',
    },
}
